/**
 * Design tokens — mirror of /packages/design-tokens/tokens.json
 *
 * En V2, ce fichier sera auto-généré via Style Dictionary.
 * Pour l'instant, on duplique manuellement pour rester simple.
 */

export const tokens = {
  color: {
    brand: {
      primary: "#2563FF",       // CORTEX primary
      accentCyan: "#22D3EE",    // neural pulse
      accentPurple: "#6D5DFB",  // Cortex IA / Assist
      navy: "#071B34",          // wordmark on light
      ink: "#0F172A",           // dark surface alt
      secondary: "#6D5DFB",
      success: "#2e7d32",
      warning: "#ed6c02",
      danger: "#d32f2f",
      info: "#22D3EE",
      gradient: "linear-gradient(135deg, #2563FF 0%, #22D3EE 55%, #6D5DFB 100%)",
    },
    light: {
      background: "#fafafa",
      surface: "#ffffff",
      text: "#1a1a1a",
      textMuted: "#5a5a5a",
      border: "#e0e0e0",
    },
    dark: {
      background: "#121212",
      surface: "#1e1e1e",
      surfaceAlt: "#262626",
      elevated: "#2a2a2a",
      text: "#ececec",
      textMuted: "#9e9e9e",
      border: "#2e2e2e",
      divider: "#373737",
    },
    planning: {
      salarieOnsite: "#1976d2",
      salarieRemote: "#7b1fa2",
      liberalOnsite: "#ed6c02",
      liberalRemote: "#795548",
      gapTotal: "#d32f2f",
      gapPartial: "#fbc02d",
      openShift: "#2e7d32",
    },
  },
  font: {
    family: {
      sans: "Inter, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
      mono: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace",
    },
  },
  radius: {
    sm: 4,
    md: 8,
    lg: 12,
  },
  breakpoint: {
    xs: 0,
    sm: 600,
    md: 900,
    lg: 1200,
    xl: 1536,
  },
} as const;
